import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Router } from '@angular/router';
import { UserService } from '@core/auth';
import { getHomeUrlByRole, isUserCabinetRole } from '@core/enums/entry-url.enum';

@Injectable({ providedIn: 'root' })
export class RoleBasedRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(): boolean {
    const role = this.userService.currentUserValue ? this.userService.currentUserValue.role : null;
    this.router.navigateByUrl(getHomeUrlByRole(role));
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class UserCabinetGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(): boolean {
    return this.allowUserCabinet();
  }

  canActivateChild(): boolean {
    return this.allowUserCabinet();
  }

  canLoad(): boolean {
    return this.allowUserCabinet();
  }

  private allowUserCabinet(): boolean {
    const role = this.userService.currentUserValue ? this.userService.currentUserValue.role : null;

    if (isUserCabinetRole(role)) {
      return true;
    }

    this.router.navigateByUrl(getHomeUrlByRole(role));
    return false;
  }
}
